export const types = {
  setAll: '[SetAll]Data'
}
